import React, {FunctionComponent, ChangeEvent, FormEvent, useState, useEffect, createRef} from 'react';

import {
  Grid,
  Card,
  CardContent,
  TextField,
} from '@mui/material';

import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch, RootState} from '../../../store/store';
import {updateNameAttributes,} from './user-information';
import {useTranslation} from 'react-i18next';
import {LoadingButton} from '@mui/lab';
import useValidator from '../../../helpers/hooks/use-validator';

interface Props {
}

const UserInformation: FunctionComponent<Props> = (props) => {

  const {t} = useTranslation(['settings']);

  const dispatch = useDispatch<AppDispatch>();

  const [givenName, setGivenName] = useState(useSelector((state: RootState) => state.app.attributes.given_name));
  const [familyName, setFamilyName] = useState(useSelector((state: RootState) => state.app.attributes.family_name));
  const [modified, setModified] = useState(false);
  const loading = useSelector((state: RootState) => state.pages.settings.userInformation.loading);

  const givenNameRef = createRef<HTMLInputElement>();
  const familyNameRef = createRef<HTMLInputElement>();


  useValidator( [ givenNameRef, familyNameRef ] )
    .required()
    .noEmpty()
    .noNumbersAndSpecialCharacters()
    .minLength();

  const onUserInformation = (event: FormEvent) => {
    event.preventDefault();

    const target = event.target as HTMLFormElement;
    const data = Object.fromEntries(new FormData(target));

    dispatch(updateNameAttributes({
      given_name: ( data.given_name.toString().trim() as string ).trim(),
      family_name: ( data.family_name.toString().trim() as string ).trim(),
    }));


  }

  return (
    <div>
    <Card>
      <CardContent>
        <h2>{ t( 'update-user-information' ) }</h2>
        <form onSubmit={ onUserInformation }>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <TextField
                value={givenName}
                inputRef={ givenNameRef }
                onChange={(event: ChangeEvent) => {
                  const target = event.target as HTMLInputElement;
                  setGivenName(target.value);
                  setModified(true);
                }}
                label={t('firstname')}
                name="given_name"
                variant='standard'
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={familyName}
                inputRef={ familyNameRef }
                onChange={(event: ChangeEvent) => {
                  const target = event.target as HTMLInputElement;
                  setFamilyName(target.value);
                  setModified(true);
                }}
                label={t('surname')}
                name="family_name"
                variant='standard'
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" sx={{mt: 4,}}>
            <LoadingButton
              loading={loading === 'pending'}
              disabled={!modified}
              variant='contained'
              type="submit"
            >{ t( 'save' ) }</LoadingButton>
          </Grid>
        </form>
      </CardContent>
    </Card>
    </div>
  );

}

export default UserInformation;
